import { useEffect } from 'react';
import { message } from 'antd';

import { getMessageInError } from '../../../hooks/fetch';
import { usePhoneNumber } from '../../../hooks/api/claimBusiness';

const usePhoneCode = () => {
  const {
    fetch, response, error, loading,
  } = usePhoneNumber();

  useEffect(() => {
    if (response) {
      message.success('Verification code sent successfully');
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      message.error(getMessageInError(error));
    }
  }, [error]);

  return {
    fetch,
    response,
    error,
    loading,
  };
};

export default usePhoneCode;
